import { atom } from "recoil";
const parksState = atom({
  key: "parks",
  default: []
});

export { parksState };